import { IFSecure, IServiceStatus } from "@nju/data-access-portal-product";

export function getFSecureServiceStatus(
  fSecure?: IFSecure,
): IServiceStatus["fSecureServiceStatus"] {
  if (!fSecure) {
    return;
  }

  return fSecure.status;
}
